"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNumberForSms = exports.containsAirtime = exports.isAirtimeOnly = exports.removeUndefinedProperties = exports.convert_number = void 0;
var constants_1 = require("../screens/pages/constants");
function convert_number(phone_number) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            if (typeof phone_number === "string" || !phone_number) {
                response = {
                    phone_number: phone_number !== null && phone_number !== void 0 ? phone_number : "",
                    country_code: "+264",
                    country_abbreviation: "NA",
                };
            }
            else {
                response = phone_number;
            }
            return [2 /*return*/, response];
        });
    });
}
exports.convert_number = convert_number;
function removeUndefinedProperties(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (obj[key] && typeof obj[key] === "object") {
                // Recursively convert falsy values to null for nested objects
                removeUndefinedProperties(obj[key]);
            }
            else {
                // Convert falsy values to null
                obj[key] = obj[key] || null;
            }
        }
    }
    return obj;
}
exports.removeUndefinedProperties = removeUndefinedProperties;
function isAirtimeOnly(product_list) {
    return __awaiter(this, void 0, void 0, function () {
        var artimeOnly;
        return __generator(this, function (_a) {
            artimeOnly = true;
            product_list === null || product_list === void 0 ? void 0 : product_list.forEach(function (product) {
                var _a, _b;
                if (((_b = (_a = product === null || product === void 0 ? void 0 : product.category) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.toLowerCase()) != constants_1.AIRTIME_TOPUP) {
                    artimeOnly = false;
                    return;
                }
            });
            return [2 /*return*/, artimeOnly];
        });
    });
}
exports.isAirtimeOnly = isAirtimeOnly;
function containsAirtime(product_list) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var _i, product_list_1, product;
        return __generator(this, function (_c) {
            if (!product_list || product_list.length === 0) {
                return [2 /*return*/, false];
            }
            for (_i = 0, product_list_1 = product_list; _i < product_list_1.length; _i++) {
                product = product_list_1[_i];
                if (((_b = (_a = product === null || product === void 0 ? void 0 : product.category) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.toLowerCase()) == constants_1.AIRTIME_TOPUP) {
                    return [2 /*return*/, true];
                }
            }
            return [2 /*return*/, false];
        });
    });
}
exports.containsAirtime = containsAirtime;
function formatNumberForSms(cell_number) {
    var _a;
    var formated = ((_a = cell_number === null || cell_number === void 0 ? void 0 : cell_number.country_code) === null || _a === void 0 ? void 0 : _a.substring(1)) + (cell_number === null || cell_number === void 0 ? void 0 : cell_number.phone_number.substring((cell_number === null || cell_number === void 0 ? void 0 : cell_number.phone_number.length) - 9));
    return formated;
}
exports.formatNumberForSms = formatNumberForSms;
